import { API_BASE } from './apiClient';
const API = API_BASE;

export interface AuthMe {
  authenticated: boolean;
  userId?: number;
  email?: string;
  cimaRole?: 'ADMIN' | 'MANAGER' | 'USER' | null;
  clientId?: number;
  firstName?: string | null;
  lastName?: string | null;
  jobTitle?: string | null;
  /** Resolved name from cima_staff (first + last), falls back to the email
   *  local-part when no staff record exists for the user yet. */
  displayName?: string | null;
}

export async function fetchMe(email?: string): Promise<AuthMe> {
  const headers: Record<string, string> = {};
  if (email) headers['X-User-Email'] = email;
  const res = await fetch(`${API}/cima/auth/me`, { headers });
  return res.json();
}
